import React, { Component, Fragment } from 'react';
import { Product } from '~/Api/Product';
import { Price } from '~/DatasourceComputedPrice';
import { ProductPrice } from '~/Product';
import ActivityIndicator from '~/UI/ActivityIndicator';

import styles from './styles.less';

interface Props {
	priceType: string | null;
	price: ProductPrice | null;
	product: Product;
	datasourceComputedPrice: Price | null;
	isFetching: boolean;
}

export default class Detail extends Component<Props> {
	render() {
		const { priceType, product, price, datasourceComputedPrice, isFetching } = this.props;
		if (isFetching) {
			return <ActivityIndicator />;
		}

		if (!product.hasAnyPrice()) {
			return <p className={styles.paragraph}>The product has no information about price in the original datasource</p>;
		}

		if (datasourceComputedPrice === null) {
			return (
				<p className={styles.paragraph}>
					Formula to calculate {priceType} price is not available for this dataset. Please contact us if you want to use
					your own formula.
				</p>
			);
		}

		if (price?.origin?.isComputed) {
			return (
				<Fragment>
					<p className={styles.paragraph}>
						Provided {priceType} price is calculated with the formula below. It reflects national legislations and
						methodologies. Please contact us if you want to use your own formula.
					</p>
					<hr className={styles.line} />
					<div className={styles.formula}>{datasourceComputedPrice.formula}</div>
				</Fragment>
			);
		}

		return null;
	}
}
